import type { ReactNode } from 'react';
import { Column } from '@simplywallst/ui-core';
import { CollapsibleRows } from './styled';

interface Props {
  children: ReactNode;
  hideBorder?: boolean;
}

const RowCol = ({ children, hideBorder }: Props) => (
  <CollapsibleRows hideBorder={hideBorder}>
    <Column>{children}</Column>
  </CollapsibleRows>
);

export default RowCol;
